import http from '../../utils/fetch'

export default {
    baseurl: '/api/swyl/v1/dscCostReduction/materialConfig',
    // 分页查询
    selectPage(f) {
        return http({
            url: this.baseurl + '/selectPage',
            method: 'post',
            data: f
        });
    },
    // 列表查询
    selectList(f) {
        return http({
            url: this.baseurl + '/selectList',
            method: 'post',
            data: f
        });
    },
    // 查单条
    selectById(id) {
        return http({
            url: this.baseurl + '/selectById',
            method: 'post',
            params: { id: id }
        });
    },
    // 新增
    insert(f) {
        return http({
            url: this.baseurl + '/insert',
            method: 'post',
            data: f
        });
    },
    // 修改
    updateById(f) {
        return http({
            url: this.baseurl + '/updateById',
            method: 'post',
            data: f
        });
    },
    // 删除
    deleteById(id) {
        return http({
            url: this.baseurl + '/deleteById',
            method: 'post',
            params: { id: id }
        });
    },
    // 分页查询物料列表
    selectMaterialList(f) {
        return http({
            url: this.baseurl + '/selectMaterialList',
            method: 'post',
            params: f
        });
    },
    // 导出
    downloadExcel(f) {
        return http({
            url: this.baseurl + '/downloadExcel',
            method: 'get',
            params: f,
            responseType: 'blob'
        });
    },
}
